/* eslint-disable no-restricted-syntax */
import { IS_DEBUG, PAGINATION_NEIGHBOR_COUNT } from "./_constants";
import { MicroCMSListContent, MicroCMSListResponse } from "./interfaces/_microcms-types";

function makeListQueryString(paged?: number): string {
  const params = [];
  if (paged && paged !== 1) {
    params.push(`paged=${paged}`);
  }
  const queryString = params.length !== 0 ? `?${params.join("&")}` : "";
  return queryString;
}

function makeDetailQueryString(id: string) {
  return `?id=${id}`;
}


export function makeNewsListUrl(paged?: number): string {
  const queryString = makeListQueryString(paged);
  return `${window.relRoot}news/${queryString}`;
}

export function makeNewsDetailUrl(id: string): string {
  const queryString = makeDetailQueryString(id);
  return `${window.relRoot}news/detail/${queryString}`;
}

export function makeExhibitorListUrl(paged?: number): string {
  const queryString = makeListQueryString(paged);
  return `${window.relRoot}exhibitors/${queryString}`;
}

export function makeExhibitorDetailUrl(id: string): string {
  const queryString = makeDetailQueryString(id);
  return `${window.relRoot}exhibitors/detail/${queryString}`;
}

interface PaginationData {
  currentPaged: number;
  totalPageCount: number;
  canGoPrev: boolean;
  canGoNext: boolean;
  pagedList: number[];
}

export function makePaginationData<T extends MicroCMSListContent>(listResponse: MicroCMSListResponse<T>): PaginationData {

  const totalPageCount = Math.ceil(listResponse.totalCount / listResponse.limit);
  const currentPaged = Math.ceil(listResponse.offset / listResponse.limit) + 1;
  if (IS_DEBUG) {
    console.log(`${currentPaged}/${totalPageCount}`);
  }

  const pagedList = Array.from({ length: totalPageCount }).map((_, i) => i + 1).filter((paged) => (currentPaged - PAGINATION_NEIGHBOR_COUNT <= paged) && (paged <= currentPaged + PAGINATION_NEIGHBOR_COUNT));
  return {
    currentPaged,
    totalPageCount,
    canGoPrev: currentPaged > 1,
    canGoNext: currentPaged < totalPageCount,
    pagedList,
  };
}


export function setupPagination(paginationElement: HTMLElement, paginationData: PaginationData) {

  if (paginationData.totalPageCount <= 1) {
    // DO NOTHING
    return;
  }


  if (paginationData.canGoPrev) {
    const prevElement = document.createElement("a");
    prevElement.href = makeNewsListUrl(paginationData.currentPaged - 1);
    prevElement.textContent = "PREV";
    prevElement.classList.add("c-pagination__prev");
    paginationElement.appendChild(prevElement);
  }

  for (const paged of paginationData.pagedList) {
    let pagedElement;
    if ((paged === paginationData.currentPaged)) {
      pagedElement = document.createElement("span");
      pagedElement.classList.add("c-pagination__number--current");
    } else {
      pagedElement = document.createElement("a");
      pagedElement.href = makeNewsListUrl(paged);
    }
    pagedElement.classList.add("c-pagination__number");
    pagedElement.textContent = `${paged}`;
    paginationElement.appendChild(pagedElement);

  }


  if (paginationData.canGoNext) {
    const nextElement = document.createElement("a");
    nextElement.href = makeNewsListUrl(paginationData.currentPaged + 1);
    nextElement.classList.add("c-pagination__next");
    nextElement.textContent = "NEXT";
    paginationElement.appendChild(nextElement);
  }

}